import { localStorageStore } from "react-admin"

export const store = localStorageStore(undefined, 'mcs')
